import { h } from 'preact';
import { useStore } from 'src/hooks';
import UserType from 'src/common/usertype';
import { studioSidebarNavigationSectionLoggedIn } from './data';
import { SidebarNavigationItem, SidebarNavigationSection } from './types';
import LogonRegister from 'src/components/sidebar/logon-register';
import * as styles from './styles.less';

interface SidebarNavigationProps {
    isFrame?: boolean;
}

const SidebarNavigationStudio = ({ isFrame }: SidebarNavigationProps) => {
    const ctx = useStore();
    const isLoggedIn = ctx.user.isLoggedIn.value && ctx.user.userTypeID.value === UserType.STUDIO;

    if (isLoggedIn === false) {
        return <LogonRegister isFrame={isFrame} prefix="studio" />;
    }

    return (
        <nav class={styles.sidebar__nav}>
            {studioSidebarNavigationSectionLoggedIn.map((section: SidebarNavigationSection) => {
                const sectionIDClass = styles[`id__${section.id}`];
                const sectionIconClass = `${styles.section__title} ${styles.section__icon} ${sectionIDClass}`;
                return (
                    <div class={styles.sidebar__section} key={section.id}>
                        <h5 class={sectionIconClass}>{section.category}</h5>
                        <div class={styles.section__links}>
                            {section.items.map((item: SidebarNavigationItem) => {
                                return (
                                    <a href={item.path} key={item.id} title={item.title ? item.title : item.name} class={`${styles.sidebar__link} ${item.isNew ? styles.sidebar__link_new : ''}`} data-native={isFrame ? true : item.isNative} target={isFrame && item.frameTarget ? item.frameTarget : item.target}>
                                        {item.name}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </nav>
    );
};

export default SidebarNavigationStudio;
